module.exports = __webpack_public_path__ + "img/c6ea16383a294e85841e20e999858141.png";